import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Confirm leaving unsaved job
 */
@Component({
  template: `
    <div mat-dialog-content>
      <h2>{{ 'post_job_alert_unsaved_title' | translate }}</h2>
      <p>{{ 'post_job_alert_unsaved_message' | translate }}</p>
    </div>
    <div mat-dialog-actions>
      <div fxLayoutAlign="space-between" fxFlex>
        <div>
          <button (click)="backToEditHandler()" mat-button>
            {{ 'post_job_alert_unsaved_back_to_edit_btn' | translate }}
          </button>
        </div>

        <div>
          <button (click)="exitWithoutSaveHandler()" mat-button>
            {{ 'post_job_alert_unsaved_exit_without_btn' | translate }}
          </button>

          <button (click)="saveAndExitHandler()" color="primary" mat-button>
            {{ 'post_job_alert_unsaved_save_and_exit_btn' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .mat-dialog-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 30px;
      }
    `,
  ],
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  backToEditHandler() {
    this.dialogRef.close();
  }

  exitWithoutSaveHandler() {
    this.dialogRef.close('exit');
  }

  saveAndExitHandler() {
    this.dialogRef.close('save');
  }
}
